import {HEX, RGBArray, RGBTuple} from "../types/colors";
import {baseTenToSixteen} from "./math";

// Function to convert hex color to RGBArray
export function hexToRGBArray(hex:HEX):RGBArray {
    const cleanHex = hex.replace(/^#/, '');
    const r = parseInt(cleanHex.slice(0, 2), 16);
    const g = parseInt(cleanHex.slice(2, 4), 16);
    const b = parseInt(cleanHex.slice(4, 6), 16);
    return [r, g, b];

}

// Function to convert RGBArray to hex color
export function rgbToHex(rgb: RGBArray): HEX {
    const [r, g, b] = rgb;
    const hex = `#${baseTenToSixteen(r)}${baseTenToSixteen(g)}${baseTenToSixteen(b)}`;
    return hex as HEX;
}

export function parseRGBTuple(tuple: RGBTuple): RGBArray {
    const values = tuple.slice(1, -1).split(',').map(val => parseInt(val, 16));
    return [values[0], values[1], values[2]];
}


